module.exports = __webpack_public_path__ + "img/banner4.746b3913.jpg";